import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { tailwindVariants } from "@air/tailwind-variants";
import { SEARCH_TOKEN_CLOSE_BTN } from "~/constants/testIDs";
import { preventDefaultMouseEvent } from "~/utils/ClickUtils";
const searchTokenVariants = tailwindVariants({
    base: "flex max-w-[120px] items-center rounded-6 py-0.5 pl-2 pr-1",
    variants: {
        color: {
            grey: "bg-grey-4 text-grey-11",
            blue: "bg-blue-1 text-blue-11"
        }
    }
});
export const SearchToken = (param)=>{
    let { icon, tokenName, onCloseClick, color, tooltipText, onMouseLeave, onMouseEnter, testId } = param;
    return /*#__PURE__*/ _jsxs("div", {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-testid": testId,
        className: searchTokenVariants({
            color
        }),
        children: [
            icon,
            !!tokenName && /*#__PURE__*/ _jsx(Tooltip, {
                label: tooltipText || tokenName,
                side: "top",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "mr-1 truncate text-14 font-medium",
                    children: tokenName
                })
            }),
            !!onCloseClick && /*#__PURE__*/ _jsx(IconButton, {
                label: "Remove from search",
                "data-testid": SEARCH_TOKEN_CLOSE_BTN,
                icon: Close,
                onMouseDown: preventDefaultMouseEvent,
                onClick: onCloseClick,
                appearance: color === "grey" ? "filled" : "ghost",
                color: color === "grey" ? "grey" : "blue",
                size: "extra-small",
                className: "!h-3 !w-3"
            })
        ]
    });
};
